import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useFmt } from "../context/CurrencyContext";
import { resolveImageUrl } from "../components/ImageUpload";
import StarRating from "../components/StarRating";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const fmtJMD = useFmt();
  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 py-12 sm:py-16" data-testid="shop-page">
      <div className="mb-10 sm:mb-12">
        <div className="overline text-zinc-500 mb-3">The catalogue</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight">All flavours</h1>
        <p className="mt-3 sm:mt-4 text-zinc-600 text-base sm:text-lg max-w-2xl">
          Every pop is JMD $650 and made from real fruit. Stock updates in real-time — order early for your favourites.
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
        {products.map((p) => {
          const soldOut = p.in_stock === false || p.stock === 0;
          return (
            <Link key={p.id} to={`/product/${p.id}`} className="group" data-testid={`shop-product-${p.id}`}>
              <div className="aspect-square rounded-2xl overflow-hidden bg-white border border-zinc-100 relative">
                <img src={resolveImageUrl(p.image_url)} alt={p.name}
                     className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                {soldOut && (
                  <div className="absolute inset-0 bg-white/80 flex items-center justify-center">
                    <span className="text-xs font-bold px-3 py-1 rounded-full bg-zinc-900 text-white">Sold out</span>
                  </div>
                )}
              </div>
              <div className="mt-3">
                <div className="font-semibold text-sm">{p.name}</div>
                <div className="flex items-center justify-between gap-2">
                  <div className="text-xs text-zinc-500">{fmtJMD(p.price)}</div>
                  {(p.rating_count || 0) > 0 && (
                    <StarRating rating={p.rating_avg || 0} size={11} showNumber count={p.rating_count} />
                  )}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
